export const formatAmount = (amount) => {
  const num = Number(amount);
  if (isNaN(num)) return amount;
  return num.toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatKenyanPhoneNumber = (value) => {
  // Remove all non-digits
  let phone = value.replace(/\D/g, "");

  // Ensure it starts with 0
  if (phone.length > 0 && phone[0] !== "0") {
    phone = "0" + phone;
  }

  // Enforce max length of 10 digits
  return phone.slice(0, 10);
}